import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
const Target = () => {
    return (
        <div className="rgs-target">
            <FullWrapper>
                <div className="rgs-targetWrapper">
                    <div className="rgs-targetLeft">Цель</div>
                    <div className="rgs-targetRight">
                        Запуск единой собственной системы автоматизации процессов продаж договоров
                        КАСКО и&nbsp;ОСАГО.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Target;
